import { ColorVariable, type Theme } from '../core/theme.types'

const movingwaldoTheme: Theme = {
  [ColorVariable.Primary]: 'rgb(250, 55, 44)',
  [ColorVariable.PrimaryContrast]: 'rgb(255, 255, 255)',
}

export default movingwaldoTheme
